import { cn } from '@/lib/utils';
import type { SVGProps } from 'react';

export function WhatsAppIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="currentColor"
      aria-hidden="true"
      className={cn('h-5 w-5', className)}
      {...props}
    >
      <path d="M19.11 17.25c-.29-.15-1.69-.83-1.95-.92-.26-.1-.45-.15-.64.15-.19.29-.74.92-.9 1.1-.17.19-.33.22-.62.08-.29-.15-1.21-.45-2.31-1.43-.86-.76-1.44-1.7-1.61-1.98-.17-.29-.02-.44.13-.59.13-.13.29-.33.43-.5.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.5-.07-.15-.64-1.54-.88-2.1-.24-.58-.48-.5-.64-.51-.17-.01-.36-.01-.55-.01-.19 0-.5.07-.76.36-.26.29-1 1-.98 2.43.02 1.43 1.02 2.8 1.17 2.99.14.19 2.01 3.08 4.87 4.31.68.29 1.21.46 1.63.59.68.22 1.3.19 1.79.12.54-.08 1.69-.69 1.93-1.36.24-.67.24-1.24.17-1.36-.07-.12-.26-.19-.55-.34Z" />
      <path d="M27.24 4.76A15.83 15.83 0 0 0 16 0C7.18 0 0 7.17 0 16c0 2.82.74 5.58 2.15 8L0 32l8.22-2.11A15.96 15.96 0 0 0 16 32c8.82 0 16-7.17 16-16 0-4.28-1.67-8.31-4.76-11.24ZM16 29.2c-2.43 0-4.82-.64-6.92-1.84l-.5-.29-4.88 1.25 1.3-4.75-.33-.49A13.17 13.17 0 0 1 2.8 16C2.8 8.72 8.72 2.8 16 2.8c3.52 0 6.83 1.37 9.31 3.86A13.08 13.08 0 0 1 29.2 16c0 7.28-5.92 13.2-13.2 13.2Z" />
    </svg>
  );
}
